import { Timeline, Tag } from "antd";

function parseCustomDate(s) {
  if (!s) return null;
  let t = s.replace(/\s+/g, " ").trim();
  t = t.replace(/(\d{1,2}:\d{2}:\d{2}):(\d{1,3})(AM|PM)$/, "$1.$2 $3");
  try {
    const d = new Date(t);
    if (isNaN(d)) return null;
    return d;
  } catch {
    return null;
  }
}

function fmtDate(s) {
  const d = parseCustomDate(s);
  if (!d) return s;
  return d.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

function statusColor(status) {
  const key = (status || "").toLowerCase();
  if (key.includes("pending") || key.includes("processing")) return "orange";
  if (key.includes("confirmed") || key.includes("completed") || key.includes("delivered")) return "green";
  if (key.includes("rejected") || key.includes("cancelled") || key.includes("failed")) return "red";
  return "gray";
}

export default function OrderStatusTimeline({ logs }) {
  const safeLogs = Array.isArray(logs) ? logs : [];

  const sorted = [...safeLogs].sort((a, b) => {
    const da = parseCustomDate(a.OrderStatusDateTime) || new Date(0);
    const db = parseCustomDate(b.OrderStatusDateTime) || new Date(0);
    return da - db;
  });

  const lastIndex = sorted.length - 1;

  return (
    <>
      <h3 className="text-xl font-semibold px-4 pt-4 text-gray-800">Order Timeline</h3>
      <div className="max-w-2xl mx-auto px-4 pt-4">
        {sorted.length === 0 ? (
          <p className="text-sm text-gray-500">No events to show</p>
        ) : (
          <Timeline>
            {sorted.map((item, idx) => {
              const isLatest = idx === lastIndex;

              return (
                <Timeline.Item key={item.OrderStatusId} color={statusColor(item.OrderStatus)}>
                  <div className="flex items-center justify-between">
                    <h4 className={`font-semibold ${isLatest ? "text-green-700" : "text-gray-800"}`}>
                      {item.OrderStatus}
                    </h4>
                    {isLatest && (
                      <Tag color="green" className="ml-2">
                        Current
                      </Tag>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">{fmtDate(item.OrderStatusDateTime)}</p>
                </Timeline.Item>
              );
            })}
          </Timeline>
        )}
      </div>
    </>
  );
}
